import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { choose } from "lit/directives/choose.js";
import { BaseElement } from "../BaseElement";
import { styles } from "./UserProfile.style";
import { LightTheme } from "../ThemeLight";
import { watch } from "../internal/watch";
import { IUserInfo } from "../../backend/cloud/UserTable";

import "@lit-labs/virtualizer";

import "../MediaThumbnailGrid/MediaThumbnailGrid";
import "../PlaceReport/PlaceReport";
import "../UserProfileBanner/UserProfileBanner";
import "../UserProfilePosts/UserProfilePosts";
import "../UserProfileGallery/UserProfileGallery";
import "../UserProfileLists/UserProfileLists";

@customElement("ds-user-profile")
export class UserProfile extends BaseElement {
    static override styles = [styles, LightTheme];

    @property({ type: String }) userId?: string;
    @property({ type: Boolean }) noCloseButton = false;

    @state() protected _userInfo?: IUserInfo;
    @state() protected _currentView = "Posts";

    @watch("userId")
    async onUserIdUpdate() {
        this._userInfo = undefined;
        if (this.userId) {
            const us = this._kernel.userSettings;
            this._userInfo = await us.read(this.userId);
        }
    }

    override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this.addEventListener("ds-show-view", (e: CustomEvent) => this._setView(e.detail.view));
    }

    private _setView(view: string) {
        this._currentView = view;
    }

    override render() {
        return html` <div class="container flex-column" slot="body">
            <div class="banner ds-box-shadow">
                <ds-user-profile-banner
                    .userInfo=${this._userInfo}
                    .currentView=${this._currentView}
                ></ds-user-profile-banner>
            </div>
            <article class="body ${this._currentView}">
                ${choose(this._currentView, [
                    [
                        "Posts",
                        () =>
                            html`<ds-user-profile-posts
                                .userInfo=${this._userInfo}
                            ></ds-user-profile-posts>`,
                    ],
                    [
                        "Gallery",
                        () =>
                            html`<ds-user-profile-gallery
                                .userInfo=${this._userInfo}
                            ></ds-user-profile-gallery>`,
                    ],
                    ["Lists", () => html`<ds-user-profile-lists></ds-user-profile-lists>`],
                    [
                        "Settings",
                        () => html`<ds-user-settings-control showAll></ds-user-settings-control>`,
                    ],
                ])}
            </article>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-user-profile": UserProfile;
    }
}
